import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ChangeRequestService } from '../../../../services/change-request.service';
import { ClientSelectionState } from '../../../../state/ClientSelectionState/ClientSelection.state';
import {
  AddressChangeRequest,
  AERequestStatusType,
  ChangeRequestData,
  ChangeRequestHistoryEntry,
  DirectDepositRequest
} from '../../../../models/change-requests';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'lib-pending-request-tab',
  templateUrl: './pending-request-tab.component.html',
  styleUrls: ['./pending-request-tab.component.css'],
  standalone: false
})
export class PendingRequestTabComponent implements OnInit {
  public requests: ChangeRequestHistoryEntry[] = [];
  changeRequestData: ChangeRequestData<AddressChangeRequest>;
  directDepositRequestData: ChangeRequestData<DirectDepositRequest>;
  selectedRequest: ChangeRequestHistoryEntry;
  constructor(
    private store: Store,
    private changeRequestService: ChangeRequestService
  ) {}

  private readonly toastService = inject(ToastService);

  ngOnInit(): void {
    this._loadTable();
  }
  viewRequest(request: ChangeRequestHistoryEntry) {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      if (request.RequestType == 'Address Change') {
        this.changeRequestService.getAddressRequestData(code, request.Id).subscribe(data => {
          this.changeRequestData = data;
          this.selectedRequest = request;
        });
      } else if (request.RequestType == 'Direct Deposit Change') {
        this.changeRequestService.getDirectDepositRequestData(code, request.Id).subscribe(data => {
          this.directDepositRequestData = data;
          this.selectedRequest = request;
        });
      }
    });
  }

  modalClosed(result: { Operation: 'accept' | 'decline' | 'dismiss'; Result: boolean }) {
    this.changeRequestData = null;
    this.directDepositRequestData = null;
    this.selectedRequest = null;
    switch (result.Operation) {
      case 'accept':
        this.toastService.show('Request accepted');
        break;
      case 'decline':
        this.toastService.show('Request declined');
        break;
    }
    this._loadTable();
  }

  private _loadTable() {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      this.changeRequestService
        .getRequestsApprover(code, AERequestStatusType.Open)
        .subscribe(requests => {
          this.requests = requests;
        });
    });
  }
}
